import { Ng1StateDeclaration } from "@uirouter/angularjs";
import { modal } from "@gtmhub/core/routing";

export const editUserDetailsStates = (base: string): Ng1StateDeclaration[] => [
  modal({
    name: `${base}._edit`,
    view: "editModal",
    windowClass: "medium edit-user-modal",
    abstract: true,
    backdrop: false,
  }),
  {
    name: `${base}._edit.editLicense`,
    data: {
      requiresLogin: true,
      trackingPage: "Edit User License",
    },
    url: "edit-license/",
    params: {
      id: null,
    },
    views: {
      "editModal@": {
        template: require("../users/views/edit-user-license.html"),
        controller: "EditUserLicenseCtrl",
      },
    },
  },
];

export const userDetailsStates = (base: string): Ng1StateDeclaration[] => [
  modal({
    name: `${base}._detail`,
    view: "userdetailview",
    windowClass: "user-profile-sidebar",
    abstract: true,
    data: {
      trackingPage: "User Detail View",
    },
  }),
  {
    name: `${base}._detail.detail`,
    data: {
      requiresLogin: true,
      titleExpression: "user.firstName + ' ' + user.lastName",
      trackingPage: "User Detail View",
    },
    url: ":id/user-details/",
    views: {
      "userdetailview@": {
        template: require("../users/views/user-detail-view.html"),
        controller: "UserDetailsViewCtrl",
      },
    },
  },
  ...editUserDetailsStates(`${base}._detail.detail`),
];
